import { useState } from 'react';
import type { FormEvent } from 'react';

interface SavedViewDialogProps {
  search: string;
  onClose: () => void;
  onSave: (name: string) => void;
}

export function SavedViewDialog({ search, onClose, onSave }: SavedViewDialogProps) {
  const [name, setName] = useState('');

  function handleSubmit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onSave(trimmed);
  }

  return (
    <div className="drawer-overlay centered-overlay" role="presentation" onClick={onClose}>
      <form
        className="confirmation-dialog saved-view-dialog"
        aria-label="Save current inventory view"
        onClick={(event) => event.stopPropagation()}
        onSubmit={handleSubmit}
      >
        <div className="drawer-heading">
          <div>
            <h2>Save current view</h2>
          </div>
          <button
            type="button"
            className="icon-button"
            onClick={onClose}
            aria-label="Close saved view dialog"
          >
            ×
          </button>
        </div>
        <label>
          View name
          <input
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="For example: Fjord exceptions"
            autoFocus
            required
          />
        </label>
        <dl className="review-grid">
          <dt>Filters</dt>
          <dd className="mono saved-view-filter-summary">{search || 'All inventory'}</dd>
          <dt>Availability</dt>
          <dd>Stored locally</dd>
        </dl>
        <div className="dialog-actions">
          <button type="button" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="primary" disabled={!name.trim()}>
            Save view
          </button>
        </div>
      </form>
    </div>
  );
}
